import { getIdentifier } from '~/mst/utils';
import { ThresholdGroup, RangeItem } from '~/utils/threshold_groups';
import { IDevicePofileModel } from './model';
import { ReportAirQualityStandardsTypes } from '../report/types';
import mappings from '~/jest/factories/data_points/mappings';

type ParameterInfo = { name: string; unit?: string };
type ParametersMap = Record<string, ParameterInfo>;

export default (self: IDevicePofileModel) => ({
  get presentName() {
    return self.name;
  },
  get isCustom() {
    return getIdentifier(self) === ReportAirQualityStandardsTypes.air_quality_custom;
  },
  get thresholdGroups(): ThresholdGroup[] {
    const ranges = self.ranges as Record<string, RangeItem[]> | undefined;
    const parameters = self.parameters as ParametersMap | undefined;

    if (!ranges) return [];

    const groupMap = new Map<string, ThresholdGroup & { seenRangeKeys: Set<string> }>();

    for (const [path, rangeArray] of Object.entries(ranges)) {
      const paramInfo = parameters?.[path] || mappings[path];
      const name = paramInfo?.name ?? path;
      const unit = paramInfo?.unit ?? '';
      const key = `${name.trim().toLowerCase()}__${unit.trim().toLowerCase()}`;

      if (!groupMap.has(key)) {
        groupMap.set(key, { name, unit: unit || undefined, ranges: [], paths: [], seenRangeKeys: new Set() });
      }
      const group = groupMap.get(key)!;

      for (const rangeItem of rangeArray) {
        const rangeKey = [rangeItem.lt, rangeItem.gt, rangeItem.lte, rangeItem.gte, rangeItem.status].join('|');
        if (!group.seenRangeKeys.has(rangeKey)) {
          group.seenRangeKeys.add(rangeKey);
          group.ranges.push(rangeItem);
        }
      }
      group.paths.push(path);
    }

    return Array.from(groupMap.values())
      .map(({ seenRangeKeys, ...group }) => group) // eslint-disable-line @typescript-eslint/no-unused-vars
      .sort((a, b) => {
        const nameCmp = a.name.localeCompare(b.name);
        if (nameCmp !== 0) return nameCmp;
        return (a.unit ?? '').localeCompare(b.unit ?? '');
      });
  }
});
